<template>
  <footer class="py-4 bg-black">
    <div class="container mx-auto px-4">

        <div class="w-full pb-10">
          <div class="p-2 flex flex-col items-center max-h-full">
            <img class="max-h-full object-contain max-w-xs" src="@/assets/logopie.png"/>
          </div>
        </div>

      
      <p class="text-sm text-center text-white">© 2023 Torneos. Todos los derechos reservados.</p>
    </div>
  </footer>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'FooterSection',
   methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>